document.addEventListener('DOMContentLoaded', function () {

  // FLIP 3D
  document.querySelectorAll('.kora-mode-flip').forEach(card => {
    card.addEventListener('click', () => {
      card.classList.toggle('kora-flipped');
    });
  });

  // REVEAL (overlay rojo)
  document.querySelectorAll('.kora-mode-reveal').forEach(card => {
    card.addEventListener('click', () => {
      card.classList.toggle('kora-revealed');
    });
  });

});
